import {
  priceReducedIconSvg,
  callForPriceCommunityIconSvg,
  callForPriceHomeIconSvg,
  callForPriceCommunityActiveIconSvg,
  callForPriceHomeActiveIconSvg,
  markerArrowHoverIconSvg,
  markerArrowIconSvg,
  ratingStartIconSvg,
  markerTipIconSvg
} from 'constants/svg-assets';

const parser = new DOMParser();

export const priceReducedSvgHtml = parser.parseFromString(
  priceReducedIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

/* Returns the SVG element to use as an icon for call for price in a community. */
export const callForPriceCommunitySvgHtml = parser.parseFromString(
  callForPriceCommunityIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const callForPriceCommunityActiveSvgHtml = parser.parseFromString(
  callForPriceCommunityActiveIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

/* Returns the SVG element to use as an icon for call for price in a home. */
export const callForPriceHomeSvgHtml = parser.parseFromString(
  callForPriceHomeIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const callForPriceHomeActiveSvgHtml = parser.parseFromString(
  callForPriceHomeActiveIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const ratingStarSvgHtml = parser.parseFromString(
  ratingStartIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const markerArrowSvgHtml = parser.parseFromString(
  markerArrowIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const markerTipSvgHtml = parser.parseFromString(
  markerTipIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;

export const markerArrowHoverSvgHtml = parser.parseFromString(
  markerArrowHoverIconSvg,
  'image/svg+xml'
).documentElement.outerHTML;
